import NiceModal from "@ebay/nice-modal-react";
import { adminRequester } from "App";
import P from "components/P";
import ToolTip from "components/tooltip/tooltip";
import { t } from "i18next";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SingleAdminTable from "routes/admin/table/SingleAdminTable";
import TableSearchCard from "routes/table/search/TableSearchCard";
import style from "./ProductSalesStatistics.module.css";
import AdminImage from "components/Image/AdminImage";
import Inline from "layouts/container/Inline";

function AccountSalesStatistics() {
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const [reset, setReset] = useState(false);
  const [research, setResearch] = useState(false);
  const [limit, setLimit] = useState(20);
  const buttons = [];
  const extraCondition = { status: "customer" };
  useEffect(() => {
    adminRequester.getStatistic(
      {
        ...extraCondition,
        ...searchCondition,
        offset: page * limit,
        limit: limit,
      },
      (result) => {
        setCount(result.count);
        setMaxPage(result.count / limit);
        setData(result.data);
      }
    );
  }, [page, searchCondition, limit]);
  useEffect(() => {
    if (reset) {
      setData([]);
      setReset(false);
      setMaxPage(0);
      setCount(0);
    }
  }, [reset]);
  useEffect(() => {
    if (research) {
      adminRequester.getStatistic(
        {
          ...extraCondition,
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setCount(result.count);
          setMaxPage(result.count / limit);
          setData(result.data);
        }
      );
      setResearch(false);
    }
  }, [research]);

  const callback = (searchCondition) => {
    setPage(0);
    setSearchCondition(searchCondition);
  };

  const dataCallback = (value) => {
    setData(value);
  };

  const theader = [
    {
      width: 50,
      text: "No.",
      justifyContent: "flex-start",
      Cell: ({ index }) => index + 1,
      index: "0",
    },
    {
      width: 100,
      text: "이름",
      Cell: ({ row }) => (
        <ToolTip
          style={{
            zindex: 10,
            backgroundColor: "white",
            width: "max-content",
            padding: 3,
          }}
          title={
            <P>
              {`${row?.first_name ? row.first_name : ""}${
                row?.first_name && row?.last_name ? " " : ""
              }${row?.last_name ? row.last_name : ""}`}
            </P>
          }
        >
          <P ellipsis width="100px">
            {`${row?.first_name ? row.first_name : ""}${
              row?.first_name && row?.last_name ? " " : ""
            }${row?.last_name ? row.last_name : ""}`}
          </P>
        </ToolTip>
      ),
    },

    {
      width: 100,
      text: "구매 물품수",
      code: "count",
      Cell: ({ cell }) => Number(cell ? cell : 0).toLocaleString("ko-kr"),
    },
    {
      width: 100,
      text: "구매액",
      code: "total",
      Cell: ({ cell }) => Number(cell ? cell : 0).toLocaleString("ko-kr"),
    },
    {
      width: 100,
      text: "구매 물품수",
      code: "count",
      Cell: ({ cell }) => Number(cell ? cell : 0).toLocaleString("ko-kr"),
    },
    {
      width: 400,
      text: "상품 구매량 및 구매액",
      code: "variants",
      Cell: ({ cell }) => {
        const products = cell.reduce((acc, variant) => {
          let product = acc.find(
            (product) => product.id === variant.variant.product_id
          );
          if (product) {
            product.variants = [
              ...product.variants,
              {
                ...variant.variant,
                count: variant.count,
                total: variant.total,
              },
            ];
            product.total += variant.total;
            product.count += variant.count;
          } else {
            product = variant.variant.product;
            product.variants = [
              {
                ...variant.variant,
                count: variant.count,
                total: variant.total,
              },
            ];
            product.total = variant.total;
            product.count = variant.count;
            return [...acc, product];
          }
          return acc;
        }, []);
        return (
          <VerticalFlex gap={10}>
            {products?.map((product) => (
              <FlexChild>
                <HorizontalFlex gap={5}>
                  <FlexChild width="max-content">
                    <ToolTip
                      style={{ zIndex: 10 }}
                      title={
                        <AdminImage
                          src={product.thumbnail}
                          width={"20vh"}
                          height={"20vh"}
                        />
                      }
                    >
                      <FlexChild>
                        <AdminImage
                          src={product.thumbnail}
                          width={100}
                          height={100}
                        />
                      </FlexChild>
                    </ToolTip>
                  </FlexChild>
                  <ToolTip
                    key={product.id}
                    style={{
                      zIndex: 10,
                      backgroundColor: "white",
                      left: "-50%",
                      paddingRight: 10,
                      minWidth: 400,
                      border: "1px solid black",
                    }}
                    title={
                      <VerticalFlex gap={10}>
                        {product.variants?.map((variant) => (
                          <FlexChild key={variant.id}>
                            <HorizontalFlex gap={5}>
                              <FlexChild width="max-content">
                                <ToolTip
                                  style={{
                                    zIndex: 10,
                                  }}
                                  title={
                                    <AdminImage
                                      style={{ border: "1px solid black" }}
                                      src={variant.thumbnail}
                                      width={"20vh"}
                                      height={"20vh"}
                                    />
                                  }
                                >
                                  <FlexChild>
                                    <AdminImage
                                      src={variant.thumbnail}
                                      width={100}
                                      height={100}
                                    />
                                  </FlexChild>
                                </ToolTip>
                              </FlexChild>
                              <FlexChild>
                                <Inline>
                                  <P>{variant.title}</P>
                                  <P> (</P>
                                  <P color="red">
                                    {Number(variant.count || 0)?.toLocaleString(
                                      "ko-kr"
                                    )}
                                  </P>
                                  <P>개)</P>
                                </Inline>
                              </FlexChild>
                              <FlexChild justifyContent="flex-end" width={50}>
                                <P>
                                  {Number(variant.total || 0)?.toLocaleString(
                                    "ko-kr"
                                  )}
                                </P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                        ))}
                      </VerticalFlex>
                    }
                  >
                    <FlexChild width="max-content">
                      <Inline>
                        <P>{product.title}</P>
                        <P> (</P>
                        <P color="red">
                          {Number(product.count || 0)?.toLocaleString("ko-kr")}
                        </P>
                        <P>개)</P>
                      </Inline>
                    </FlexChild>
                  </ToolTip>
                  <FlexChild justifyContent="flex-end" width="max-content">
                    <P>{Number(product.total || 0)?.toLocaleString("ko-kr")}</P>
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
            ))}
          </VerticalFlex>
        );
      },
    },
    {
      width: 120,
      text: "구매 종류",
      Cell: ({ row }) => (
        <VerticalFlex>
          <FlexChild>
            <P>옵션 종류 : {row.v_count}종류</P>
          </FlexChild>
          <FlexChild>
            <P>(상품 종류 : {row.p_count}종류)</P>
          </FlexChild>
        </VerticalFlex>
      ),
    },
  ];

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent="flex-start">
            <FlexChild width="max-content">
              <div
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontSize: 18,
                  paddingBottom: "8px",
                  fontWeight: "700",
                }}
              >
                {t("상품 통계")}
              </div>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <TableSearchCard
            callback={callback}
            index={10}
            reset={reset}
            setReset={setReset}
            research={research}
          />
        </FlexChild>
        <FlexChild>
          <SingleAdminTable
            theader={theader}
            count={count}
            mockData={data}
            initTabIndex={0}
            callback={dataCallback}
            // output={out}
            page={page}
            buttons={buttons}
            maxPage={maxPage}
            setPage={setPage}
            limit={limit}
            reset={reset}
            research={research}
          />
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default AccountSalesStatistics;
